import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const AppointmentChart = ({ data }) => {
  const chartData = useMemo(() => {
    if (!Array.isArray(data)) return [];

    const grouped = {};

    data.forEach((item) => {
      if (!item.appointmentDate) return;

      const date = new Date(item.appointmentDate).toLocaleDateString("en-CA");

      if (!grouped[date]) {
        grouped[date] = {
          name: date,
          booked: 0,
        };
      }

      grouped[date].booked += 1;
    });

    return Object.values(grouped).sort(
      (a, b) => new Date(a.name) - new Date(b.name),
    );
  }, [data]);

  if (!chartData.length) {
    return <p style={{ textAlign: "center" }}>No data available</p>;
  }

  return (
    <div>
      <h6 className="mb-3">Appointment Trends</h6>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />

          <Line
            type="monotone"
            dataKey="booked"
            stroke="#8884d8"
            name="Booked"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AppointmentChart;
